/**
 * RevPAR 前端直调 PMS businessReportList + 本地缓存 1 天
 * 不再向后端请求 RevPAR，避免后端打日志与调第三方
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getBusinessReportListFromThirdParty, } from '../../../../service/storeRevenueApi';
import { getStoreFromLocalStorage, setStoreSliceInLocalStorage } from '../../../utils/storeRevenueLocalStorage';
var REVPAR_CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 1 天
var BUSINESS_TZ = 'Asia/Shanghai';
function formatTimestampToChinaDate(timestampSeconds) {
    return new Intl.DateTimeFormat('sv-SE', {
        timeZone: BUSINESS_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date(timestampSeconds * 1000));
}
function getChinaDateParts(timestampSeconds) {
    var _a, _b, _c, _d, _e, _f;
    var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: BUSINESS_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(new Date(timestampSeconds * 1000));
    var year = Number.parseInt((_b = (_a = parts.find(function (p) { return p.type === 'year'; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '0', 10);
    var month = Number.parseInt((_d = (_c = parts.find(function (p) { return p.type === 'month'; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '0', 10) - 1;
    var day = Number.parseInt((_f = (_e = parts.find(function (p) { return p.type === 'day'; })) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '0', 10);
    return { year: year, month: month, day: day };
}
var revparChartCache = new Map();
var inFlightRevpar = new Map();
function hasRevparDataShape(v) {
    if (v == null || typeof v !== 'object')
        return false;
    var o = v;
    return 'chartData' in o && o.chartData != null && typeof o.chartData === 'object';
}
/** 冷启动从 localStorage 恢复：若有有效数据（1 天内）则同步返回，供 hook 做初始渲染 */
export function getRevparFromLocalStorageSync(hotelId) {
    var _a;
    var stored = (_a = getStoreFromLocalStorage(hotelId)) === null || _a === void 0 ? void 0 : _a.revpar;
    if (!(stored === null || stored === void 0 ? void 0 : stored.data) || typeof stored.fetchedAt !== 'number')
        return null;
    if (Date.now() - stored.fetchedAt > REVPAR_CACHE_TTL_MS)
        return null;
    if (!hasRevparDataShape(stored.data))
        return null;
    var data = stored.data;
    revparChartCache.set(cacheKey(hotelId), { data: data, fetchedAt: stored.fetchedAt });
    return data;
}
function cacheKey(hotelId) {
    var d = new Date();
    var today = "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'));
    return "revpar:".concat(hotelId, ":").concat(today);
}
function isValid(entry) {
    return Date.now() - entry.fetchedAt < REVPAR_CACHE_TTL_MS;
}
var emptyChartData = {
    categories: [],
    dataset: { priceKlineData: [], RevPAR: [], RevPARLastYear: [] },
    axes: {
        left: { id: 'left', position: 'left', name: '可售房收入', unit: '元', min: 0, max: 100 },
    },
    series: [],
};
function buildRevparChartFromLists(thisYearList, lastYearList) {
    var sortedThis = __spreadArray([], thisYearList, true).sort(function (a, b) { return a.date - b.date; });
    var sortedLast = __spreadArray([], lastYearList, true).sort(function (a, b) { return a.date - b.date; });
    var recentMonths = sortedThis.slice(-12);
    if (recentMonths.length === 0)
        return emptyChartData;
    var categories = recentMonths.map(function (item) {
        var month = getChinaDateParts(item.date).month;
        return "".concat(month + 1, "\u6708");
    });
    var revparValues = recentMonths.map(function (item) { var _a; return Math.round((_a = item.roomRevpar) !== null && _a !== void 0 ? _a : 0); });
    var revparLastYear = recentMonths.map(function (thisYearItem) {
        var _a;
        var _b = getChinaDateParts(thisYearItem.date), year = _b.year, month = _b.month;
        var lastYearMatch = sortedLast.find(function (item) {
            var ly = getChinaDateParts(item.date);
            return ly.month === month && ly.year === year - 1;
        });
        return lastYearMatch ? Math.round((_a = lastYearMatch.roomRevpar) !== null && _a !== void 0 ? _a : 0) : 0;
    });
    var priceKlineData = recentMonths.map(function (item) {
        var _a;
        var adr = (_a = item.adr) !== null && _a !== void 0 ? _a : 0;
        var variation = adr * 0.1;
        return [
            Math.round(adr - variation),
            Math.round(adr + variation),
            Math.round(adr - variation * 0.5),
            Math.round(adr + variation * 0.5),
        ];
    });
    var allRevparValues = __spreadArray(__spreadArray([], revparValues, true), revparLastYear, true);
    var maxRevpar = Math.max.apply(Math, __spreadArray(__spreadArray([], allRevparValues, false), [1], false));
    var leftAxisMax = Math.ceil(maxRevpar * 1.2);
    return {
        categories: categories,
        dataset: { priceKlineData: priceKlineData, RevPAR: revparValues, RevPARLastYear: revparLastYear },
        axes: {
            left: {
                id: 'left',
                position: 'left',
                name: '可售房收入',
                unit: '元',
                min: 0,
                max: leftAxisMax,
            },
        },
        series: [
            { id: 'RevPAR', name: '可售房收入', dataKey: 'RevPAR', type: 'bar', axisId: 'left', color: '#5470c6' },
            { id: 'RevPARLastYear', name: '去年同期', dataKey: 'RevPARLastYear', type: 'line', axisId: 'left', color: '#91cc75', lineStyle: { type: 'dashed' } },
        ],
    };
}
function buildRevparChartFromListsDaily(thisYearList, lastYearList, dayCount) {
    var sortedThis = __spreadArray([], thisYearList, true).sort(function (a, b) { return a.date - b.date; });
    var sortedLast = __spreadArray([], lastYearList, true).sort(function (a, b) { return a.date - b.date; });
    var recentDays = sortedThis.slice(-dayCount);
    if (recentDays.length === 0)
        return emptyChartData;
    var categories = recentDays.map(function (item) {
        var _a = getChinaDateParts(item.date), month = _a.month, day = _a.day;
        return "".concat(month + 1, "/").concat(day);
    });
    var revparValues = recentDays.map(function (item) { var _a; return Math.round((_a = item.roomRevpar) !== null && _a !== void 0 ? _a : 0); });
    var revparLastYear = recentDays.map(function (thisYearItem) {
        var _a;
        var _b = getChinaDateParts(thisYearItem.date), year = _b.year, month = _b.month, day = _b.day;
        var lastYearMatch = sortedLast.find(function (item) {
            var ly = getChinaDateParts(item.date);
            return ly.month === month && ly.year === year - 1 && ly.day === day;
        });
        return lastYearMatch ? Math.round((_a = lastYearMatch.roomRevpar) !== null && _a !== void 0 ? _a : 0) : 0;
    });
    var priceKlineData = recentDays.map(function (item) {
        var _a;
        var adr = (_a = item.adr) !== null && _a !== void 0 ? _a : 0;
        var variation = adr * 0.1;
        return [
            Math.round(adr - variation),
            Math.round(adr + variation),
            Math.round(adr - variation * 0.5),
            Math.round(adr + variation * 0.5),
        ];
    });
    var allRevparValues = __spreadArray(__spreadArray([], revparValues, true), revparLastYear, true);
    var maxRevpar = Math.max.apply(Math, __spreadArray(__spreadArray([], allRevparValues, false), [1], false));
    var leftAxisMax = Math.ceil(maxRevpar * 1.2);
    return {
        categories: categories,
        dataset: { priceKlineData: priceKlineData, RevPAR: revparValues, RevPARLastYear: revparLastYear },
        axes: {
            left: {
                id: 'left',
                position: 'left',
                name: '可售房收入',
                unit: '元',
                min: 0,
                max: leftAxisMax,
            },
        },
        series: [
            { id: 'RevPAR', name: '可售房收入', dataKey: 'RevPAR', type: 'bar', axisId: 'left', color: '#5470c6' },
            { id: 'RevPARLastYear', name: '去年同期', dataKey: 'RevPARLastYear', type: 'line', axisId: 'left', color: '#91cc75', lineStyle: { type: 'dashed' } },
        ],
    };
}
var revparChartDailyCache = new Map();
var inFlightRevparDaily = new Map();
function cacheKeyDaily(hotelId, days) {
    var todayStr = formatTimestampToChinaDate(Math.floor(Date.now() / 1000));
    return "revpar:".concat(hotelId, ":daily:").concat(days, ":").concat(todayStr);
}
export function getRevparChartDailyWithCache(hotelId, days) {
    return __awaiter(this, void 0, Promise, function () {
        var key, entry, inFlight, promise;
        var _this = this;
        return __generator(this, function (_a) {
            key = cacheKeyDaily(hotelId, days);
            entry = revparChartDailyCache.get(key);
            if (entry && isValid(entry))
                return [2 /*return*/, entry.data];
            inFlight = inFlightRevparDaily.get(key);
            if (inFlight)
                return [2 /*return*/, inFlight];
            promise = (function () { return __awaiter(_this, void 0, Promise, function () {
                var now, endDateStr, startDate, startDateStr, lastYearEnd, lastYearEndStr, lastYearStart, lastYearStartStr, _a, thisYearList, lastYearList, chartData, data;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            now = Date.now();
                            endDateStr = formatTimestampToChinaDate(Math.floor(now / 1000));
                            startDate = new Date(now);
                            startDate.setDate(startDate.getDate() - days);
                            startDateStr = formatTimestampToChinaDate(Math.floor(startDate.getTime() / 1000));
                            lastYearEnd = new Date(now);
                            lastYearEnd.setFullYear(lastYearEnd.getFullYear() - 1);
                            lastYearEndStr = formatTimestampToChinaDate(Math.floor(lastYearEnd.getTime() / 1000));
                            lastYearStart = new Date(startDate.getTime());
                            lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);
                            lastYearStartStr = formatTimestampToChinaDate(Math.floor(lastYearStart.getTime() / 1000));
                            return [4 /*yield*/, Promise.all([
                                    getBusinessReportListFromThirdParty(hotelId, { dateType: 0, startDate: startDateStr, endDate: endDateStr }),
                                    getBusinessReportListFromThirdParty(hotelId, { dateType: 0, startDate: lastYearStartStr, endDate: lastYearEndStr }),
                                ])];
                        case 1:
                            _a = _b.sent(), thisYearList = _a[0], lastYearList = _a[1];
                            chartData = buildRevparChartFromListsDaily(thisYearList, lastYearList, days);
                            data = { chartData: chartData };
                            revparChartDailyCache.set(key, { data: data, fetchedAt: Date.now() });
                            return [2 /*return*/, data];
                    }
                });
            }); })().finally(function () { inFlightRevparDaily.delete(key); });
            inFlightRevparDaily.set(key, promise);
            return [2 /*return*/, promise];
        });
    });
}
export function getRevparChartWithCache(hotelId) {
    return __awaiter(this, void 0, Promise, function () {
        var key, entry, fromLocal, inFlight, promise;
        var _this = this;
        return __generator(this, function (_a) {
            key = cacheKey(hotelId);
            entry = revparChartCache.get(key);
            if (entry && isValid(entry))
                return [2 /*return*/, entry.data];
            fromLocal = getRevparFromLocalStorageSync(hotelId);
            if (fromLocal != null)
                return [2 /*return*/, fromLocal];
            inFlight = inFlightRevpar.get(key);
            if (inFlight)
                return [2 /*return*/, inFlight];
            promise = (function () { return __awaiter(_this, void 0, Promise, function () {
                var endDateObj, startDateObj, startDateStr, endDateStr, lastYearEnd, lastYearStart, lastYearStartStr, lastYearEndStr, _a, thisYearList, lastYearList, chartData, data, fetchedAt;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            endDateObj = new Date();
                            startDateObj = new Date(endDateObj);
                            startDateObj.setDate(startDateObj.getDate() - 365);
                            startDateStr = formatTimestampToChinaDate(Math.floor(startDateObj.getTime() / 1000));
                            endDateStr = formatTimestampToChinaDate(Math.floor(endDateObj.getTime() / 1000));
                            lastYearEnd = new Date(endDateObj);
                            lastYearEnd.setFullYear(lastYearEnd.getFullYear() - 1);
                            lastYearStart = new Date(startDateObj);
                            lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);
                            lastYearStartStr = formatTimestampToChinaDate(Math.floor(lastYearStart.getTime() / 1000));
                            lastYearEndStr = formatTimestampToChinaDate(Math.floor(lastYearEnd.getTime() / 1000));
                            return [4 /*yield*/, Promise.all([
                                    getBusinessReportListFromThirdParty(hotelId, { dateType: 1, startDate: startDateStr, endDate: endDateStr }),
                                    getBusinessReportListFromThirdParty(hotelId, { dateType: 1, startDate: lastYearStartStr, endDate: lastYearEndStr }),
                                ])];
                        case 1:
                            _a = _b.sent(), thisYearList = _a[0], lastYearList = _a[1];
                            chartData = buildRevparChartFromLists(thisYearList, lastYearList);
                            data = { chartData: chartData };
                            fetchedAt = Date.now();
                            revparChartCache.set(key, { data: data, fetchedAt: fetchedAt });
                            setStoreSliceInLocalStorage(hotelId, 'revpar', { data: data, fetchedAt: fetchedAt });
                            return [2 /*return*/, data];
                    }
                });
            }); })().finally(function () { inFlightRevpar.delete(key); });
            inFlightRevpar.set(key, promise);
            return [2 /*return*/, promise];
        });
    });
}
export function clearRevparCache(hotelId) {
    var prefix = "revpar:".concat(String(hotelId));
    var keysToDelete = function (map) {
        var out = [];
        map.forEach(function (_, key) { if (key.startsWith(prefix))
            out.push(key); });
        return out;
    };
    __spreadArray(__spreadArray([], keysToDelete(revparChartCache), true), keysToDelete(revparChartDailyCache), true).forEach(function (k) {
        revparChartCache.delete(k);
        revparChartDailyCache.delete(k);
        inFlightRevpar.delete(k);
        inFlightRevparDaily.delete(k);
    });
}
export function __getRevparCacheForDev() {
    return revparChartCache;
}
